<template lang="pug">
  .cursor-pointer(:class="customClasses" @click="$emit('input', radioValue)")
    div(:class="radioClasses")
      input.appearance-none.outline-none(
        :checked="value === radioValue"
        :class="checkedRadioClasses"
        :value="radioValue"
        type="radio"
      )
    slot
</template>

<script>
export default {
  name: 'GenericRadio',
  props: {
    radioValue: {
      type: [String, Boolean, Number],
      default: null,
    },
    value: {
      type: [String, Boolean, Number],
      default: null,
    },
    customClasses: {
      type: String,
      default: '',
    },
    radioClasses: {
      type: String,
      default: '',
    },
    checkedRadioClasses: {
      type: String,
      default: '',
    },
  },
};
</script>
